export function formatReducedPriceOnly(reducedPriceOnly: string | string[]) {
    if (reducedPriceOnly === 'true') {
        return 'Reduced price';
    }

    return '';
}
